import disciplineService from '../services/discipline.service';

const disciplines = {
    namespaced: true,
    state: {},
    actions: {
        //CREATE

        //READ
        get() {
            return disciplineService.get();
        },

        //UPDATE

        //DELETE
    },
    getters: {},
    mutations: {},
};

export default disciplines;